import React, { useCallback } from "react"
import { Check } from "@mui/icons-material"
import { FormControlLabel, FormGroup } from "@mui/material"
import MuiCheckBox from "@mui/material/Checkbox"
import { useFormContext, useController } from "react-hook-form"

import { FormField } from "./types"
import { trackFormEvent } from "./utils"

export interface Props extends FormField {
  onChange?: (value: boolean) => void
}

const CheckBox = ({ className, label, name, rules, tracking, onChange }: Props) => {
  const { control } = useFormContext()
  const controller = useController({ name, control, rules })

  const handleClick = useCallback(
    async (e: React.ChangeEvent<HTMLInputElement>) => {
      const checked = e.currentTarget.checked

      controller.field.onChange(checked)
      onChange?.(checked)

      if (tracking?.shouldTrackValueChange) {
        await trackFormEvent("Form Value Provided", tracking, name, label)
      }
    },
    [controller.field, label, name, onChange, tracking]
  )

  return (
    <FormGroup className={className}>
      <FormControlLabel
        control={
          <MuiCheckBox checkedIcon={<Check />} onChange={handleClick} checked={controller.field.value || false} />
        }
        label={label}
      />
    </FormGroup>
  )
}

export default CheckBox
